<template>
    <div class="modal fade" tabindex="-1" ref="modal">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Annual Training Due Date</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <FormInput v-model="dueDate" type="date"/>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-danger" @click="update">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import eventBus from '@/event-bus';
import FormInput from '@/components/form/FormInput.vue';
import AnnualTrainingService from '@/services/annual-training.service';
import FormMixin from '@/mixins/FormMixin';

export default {
    components: {
        FormInput
    },
    mixins: [
        FormMixin
    ],
    data() {
        return {
            employee: {},
            dueDate: ''
        }
    },
    mounted() {
        eventBus.$on('annualTrainingModalOpened', this.openModal);
    },
    methods: {
        openModal($event) {
            this.dueDate = $event.annualTrainingDue;
            this.employee = $event.employee;

            $(this.$refs.modal).modal('show');
        },
        async update() {
            this.pending = true;
            this.errorMessage = '';

            try {
                const annualTraining = await AnnualTrainingService.update(this.employee.id, this.dueDate);

                eventBus.$emit('notification', {
                    type: 'success',
                    message: 'Training Updated!'
                });

                eventBus.$emit('annualTrainingUpdated', {
                    annualTrainingDue: this.dueDate,
                    daysSinceAnnualTraining: annualTraining,
                    employeeId: this.employee.id
                });

                this.pending = false;
                this.success = true;
            } catch (error) {
                this.handleError(error);

                eventBus.$emit('notification', {
                    type: 'error',
                    message: this.errorMessage
                });

                this.pending = false;
            } finally {
                $(this.$refs.modal).modal('hide');
            }
        }
    }
}
</script>
